
import { Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { ChallengeStatusModule_tryParse } from "../Challenge.js";
import { SetCoverImageRequest, CoverImage_renditionDimensions, CoverImage_altText, CoverImage_hint, CoverImage_isEditable } from "../CoverImage.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { flexDirection_flexCol, cursor_cursorNotAllowed, opacity_opacity50, borderRadius_roundedMd, padding_py2, padding_px4, gap_gap$002D3, justifyContent_justifyEnd, margin_mb4, fontWeight_fontBold, fontSize_textLg, margin_mx4, width_wFull, maxWidth_wLg, padding_p6, boxShadow_shadowXl, fontWeight_fontMedium, fontSize_textSm, borderRadius_roundedLg, padding_p4, gap_gap$002D2, display_flex, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { backgroundColor_bgDanger700, hover, backgroundColor_bgDanger600, textColor_textOnDanger, textColor_textDanger600, textColor_textNeutral600, textColor_textNeutral900, backgroundColor_bgSurfaceElevated, textColor_textWarning800, backgroundColor_bgWarning50 } from "../TailwindExtensions.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { useEffect, useRef, useState, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { ModerationReasonModule_label } from "../Moderation.js";
import { ImageUploadProps, ImageUploadField, EmptyPrompt } from "../ImageUpload.js";
import { ClientTypes_PhotoUploadState } from "../ClientTypes.js";
import { UploadFailure, UploadedPhoto } from "../Photo.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { image } from "./CoverImageView.js";
import { ofNullable, toArray, bind } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { disposeSafe, equals } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { empty, singleton as singleton_1, append, delay, toList, iterate } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { Operators_IsNull } from "../../fable_modules/fable-library-js.5.3.0/FSharp.Core.js";
import { TailwindHelpers_buttonSecondary } from "../Layout/Layout.js";
import { startImmediate } from "../../fable_modules/fable-library-js.5.3.0/Async.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library-js.5.3.0/AsyncBuilder.js";
import { ApiErrorModule_message } from "../ValidationErrors.js";

export class SlotMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Editable", "ReadOnly"];
    }
}

export function SlotMode_$reflection() {
    return union_type("Shared.CoverImageSlot.SlotMode", [], SlotMode, () => [[], []]);
}

/**
 * Owner and CoverImage.isEditable status (every status but Abandoned) -> Editable. Unknown status -> ReadOnly.
 */
export function mode(isOwner, status) {
    const matchValue = ChallengeStatusModule_tryParse(status);
    let matchResult, s_1;
    if (matchValue != null) {
        if (isOwner && CoverImage_isEditable(matchValue)) {
            matchResult = 0;
            s_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new SlotMode(0, []);
        default:
            return new SlotMode(1, []);
    }
}

/**
 * Owner placeholder for a cover a moderator has hidden.
 */
export function hiddenNotice(info) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["className", tw(ofArray([display_flex, gap_gap$002D2, padding_p4, borderRadius_roundedLg, backgroundColor_bgWarning50, textColor_textWarning800, fontSize_textSm]))], ["children", [createElement(icon, {
        name: new IconName(34, []),
        size: new IconSize(1, []),
        weight: new IconWeight(1, []),
    }), HtmlHelper_createElement("div", singleton(["children", [HtmlHelper_createElement("p", ofArray([["className", tw(singleton(fontWeight_fontMedium))], ["children", singleton("Hidden by a moderator")]])), HtmlHelper_createElement("p", singleton(["children", singleton(concat("Your cover isn\'t shown to anyone. Reason: ", ModerationReasonModule_label(info.Reason)))]))]]))]]]));
}

/**
 * Why the optional cover matters, shown in the empty chooser only while the challenge has no cover at all.
 * A moderator-hidden cover gets Replace photo only; a saved cover kept visible after a failed replacement gets no prompt.
 */
export function emptyPrompt(hidden, committedUrl) {
    let matchResult;
    if (hidden == null) {
        if (committedUrl == null) {
            matchResult = 1;
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return undefined;
        default:
            return new EmptyPrompt("Add a cover image", "It\'s shown on your page and when your link is shared.");
    }
}

/**
 * The 1200x630 rendition URL fed to the upload field as ExistingPhoto, so the preview matches the public frame.
 */
export function initialUploadState(cover) {
    let matchResult, c_1;
    if (cover != null) {
        if (cover.Hidden == null) {
            matchResult = 0;
            c_1 = cover;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new ClientTypes_PhotoUploadState(3, [c_1.Url]);
        default:
            return new ClientTypes_PhotoUploadState(0, []);
    }
}

/**
 * After a save the field previews the saved 1200x630 rendition; the upload's dimensions keep the small-image warning.
 */
export function savedCoverUploadState(photo, saved) {
    return new ClientTypes_PhotoUploadState(2, [new UploadedPhoto(photo.PhotoKey, photo.PhotoUrl, saved.Url, photo.Dimensions)]);
}

/**
 * The saved cover stays visible while a replacement uploads or after it fails, until a new cover is saved.
 */
export function previousCoverPreview(committedUrl, upload) {
    switch (upload.tag) {
        case 1:
        case 4:
            return committedUrl;
        default:
            return undefined;
    }
}

export function readOnlyView(challenge) {
    const matchValue = challenge.CoverImage;
    if (matchValue == null) {
        return defaultOf();
    }
    else if (matchValue.Hidden != null) {
        const info = matchValue.Hidden;
        return hiddenNotice(info);
    }
    else {
        const url = matchValue.Url;
        return image(url, challenge.Title, singleton("rounded-lg"));
    }
}

function visibleUrl(cover) {
    let matchResult, url;
    if (cover != null) {
        if (cover.Hidden == null) {
            matchResult = 0;
            url = cover.Url;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return url;
        default:
            return undefined;
    }
}

export function CoverImageSlot($props) {
    let matchValue_2;
    const onCoverChanged = $props.onCoverChanged;
    const isOwner = $props.isOwner;
    const authToken = $props.authToken;
    const api = $props.api;
    const challenge = $props.challenge;
    const patternInput = useState(initialUploadState(challenge.CoverImage));
    const upload = patternInput[0];
    const setUpload = patternInput[1];
    const patternInput_1 = useState(bind((_arg) => _arg.Hidden, challenge.CoverImage));
    const setHidden = patternInput_1[1];
    const hidden = patternInput_1[0];
    const patternInput_2 = useState(visibleUrl(challenge.CoverImage));
    const setCommittedUrl = patternInput_2[1];
    const committedUrl = patternInput_2[0];
    const patternInput_3 = useState(false);
    const showRemoveDialog = patternInput_3[0];
    const setShowRemoveDialog = patternInput_3[1];
    const patternInput_4 = useState(undefined);
    const setRemoveError = patternInput_4[1];
    const patternInput_5 = useState(false);
    const setRemoving = patternInput_5[1];
    const removing = patternInput_5[0];
    const dialogRef = useRef(undefined);
    const dependencies = [showRemoveDialog];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const matchValue = dialogRef.current;
        if (matchValue == null) {
        }
        else {
            const dialogEl = matchValue;
            if (showRemoveDialog && !dialogEl.open) {
                dialogEl.showModal();
            }
            else if (!showRemoveDialog && dialogEl.open) {
                dialogEl.close();
                if (equals(upload, new ClientTypes_PhotoUploadState(0, []))) {
                    iterate((el) => {
                        el.focus();
                    }, toArray(ofNullable(document.getElementById("cover-image-input"))));
                }
            }
        }
        disp = {
            Dispose() {
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, dependencies);;
    const removeDialog = HtmlHelper_createElement("dialog", ofArray([["ref", (el_1) => {
        if (Operators_IsNull(el_1)) {
            dialogRef.current = undefined;
        }
        else {
            dialogRef.current = el_1;
        }
    }], ["aria-labelledby", join(" ", ["remove-cover-title"])], ["className", tw(ofArray([backgroundColor_bgSurfaceElevated, borderRadius_roundedLg, boxShadow_shadowXl, padding_p6, maxWidth_wLg, width_wFull, margin_mx4, "backdrop:bg-black/50"]))], ["onCancel", (e) => {
        if (removing) {
            e.preventDefault();
        }
        else {
            setShowRemoveDialog(false);
        }
    }], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("h3", ofArray([["id", "remove-cover-title"], ["className", tw(ofArray([fontSize_textLg, fontWeight_fontBold, textColor_textNeutral900, margin_mb4]))], ["children", singleton("Remove cover image?")]]))), delay(() => append(singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600, margin_mb4]))], ["children", singleton("Your challenge page will go back to showing no cover image.")]]))), delay(() => {
        let matchValue_1, msg;
        return append((matchValue_1 = patternInput_4[0], (matchValue_1 == null) ? singleton_1(defaultOf()) : ((msg = matchValue_1, singleton_1(HtmlHelper_createElement("p", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([fontSize_textSm, textColor_textDanger600, margin_mb4]))], ["children", singleton(msg)]])))))), delay(() => singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyEnd, gap_gap$002D3]))], ["children", [HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", TailwindHelpers_buttonSecondary], ["children", singleton("Cancel")], ["disabled", removing], ["onClick", (_arg_5) => {
            setShowRemoveDialog(false);
        }]])), HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", tw(toList(delay(() => append(singleton_1(padding_px4), delay(() => append(singleton_1(padding_py2), delay(() => append(singleton_1(fontSize_textSm), delay(() => append(singleton_1(fontWeight_fontMedium), delay(() => append(singleton_1(textColor_textOnDanger), delay(() => append(singleton_1(backgroundColor_bgDanger600), delay(() => append(singleton_1(borderRadius_roundedMd), delay(() => append(singleton_1(hover(backgroundColor_bgDanger700)), delay(() => (removing ? append(singleton_1(opacity_opacity50), delay(() => singleton_1(cursor_cursorNotAllowed))) : empty()))))))))))))))))))))], ["children", singleton(removing ? "Removing..." : "Remove")], ["disabled", removing], ["onClick", (_arg_6) => {
            setRemoving(true);
            setRemoveError(undefined);
            startImmediate(singleton_2.Delay(() => singleton_2.Combine(singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.removeCoverImage(challenge.Id), (_arg_3) => {
                const result_1 = _arg_3;
                if (result_1.tag === 1) {
                    setRemoveError(ApiErrorModule_message(result_1.fields[0]));
                    return singleton_2.Zero();
                }
                else {
                    setUpload(new ClientTypes_PhotoUploadState(0, []));
                    setHidden(undefined);
                    setCommittedUrl(undefined);
                    setShowRemoveDialog(false);
                    onCoverChanged(false);
                    return singleton_2.Zero();
                }
            })), (_arg_4) => {
                setRemoveError("An unexpected error occurred");
                return singleton_2.Zero();
            }), singleton_2.Delay(() => {
                setRemoving(false);
                return singleton_2.Zero();
            }))));
        }]]))]]])))));
    }))))))]]));
    const prompt = emptyPrompt(hidden, committedUrl);
    return HtmlHelper_createElement("div", ofArray([["id", "cover-image"], ["children", [(matchValue_2 = mode(isOwner, challenge.Status), (matchValue_2.tag === 0) ? HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flexDirection_flexCol, gap_gap$002D3]))], ["children", toList(delay(() => {
        let matchValue_3;
        return append((matchValue_3 = hidden, (matchValue_3 == null) ? singleton_1(defaultOf()) : singleton_1(hiddenNotice(matchValue_3))), delay(() => {
            let matchValue_4;
            return append((matchValue_4 = previousCoverPreview(committedUrl, upload), (matchValue_4 == null) ? singleton_1(defaultOf()) : singleton_1(image(matchValue_4, challenge.Title, singleton("rounded-lg")))), delay(() => {
                let value_45;
                return append(singleton_1(HtmlHelper_createElement("div", ofArray([(value_45 = "[&_label.border-dashed]:min-h-32 md:[&_label.border-dashed]:min-h-0 md:[&_label.border-dashed]:aspect-[1200/630]", ["className", value_45]), ["children", [createElement(ImageUploadField, {
                    props: new ImageUploadProps("cover-image-input", (hidden != null) ? "Replace photo" : "Cover image", prompt != null, CoverImage_hint, prompt, CoverImage_altText(challenge.Title), "aspect-[1200/630] w-full object-cover rounded-lg", CoverImage_renditionDimensions, upload, false, authToken, () => {
                        setUpload(new ClientTypes_PhotoUploadState(1, []));
                    }, (photo) => {
                        startImmediate(singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.setCoverImage(new SetCoverImageRequest(challenge.Id, photo.PhotoKey)), (_arg_1) => {
                            const result = _arg_1;
                            if (result.tag === 1) {
                                setUpload(new ClientTypes_PhotoUploadState(4, [new UploadFailure(3, [])]));
                                return singleton_2.Zero();
                            }
                            else {
                                const cover = result.fields[0];
                                setUpload(savedCoverUploadState(photo, cover));
                                setHidden(undefined);
                                setCommittedUrl(cover.Url);
                                onCoverChanged(true);
                                return singleton_2.Zero();
                            }
                        })), (_arg_2) => {
                            setUpload(new ClientTypes_PhotoUploadState(4, [new UploadFailure(3, [])]));
                            return singleton_2.Zero();
                        })));
                    }, (failure) => {
                        setUpload(new ClientTypes_PhotoUploadState(4, [failure]));
                    }, () => {
                        setRemoveError(undefined);
                        setShowRemoveDialog(true);
                    }),
                })]]]))), delay(() => singleton_1(removeDialog)));
            }));
        }));
    }))]])) : readOnlyView(challenge))]]]));
}

//# sourceMappingURL=CoverImageSlot.js.map
